import styled from "styled-components"
import {
  SectionWrapperStyles,
  ContentWrapperStyles,
  NewContentStyles,
  NewsWrapperStyles,
  SectionNameStyles,
  NewLeftBlockStyles,
  NewRightBlockStyles,
  NewAssetWrapperStyles,
  NewAssetStyles,
  NewTitleStyles,
  NewGameNameStyles,
  NewGameDateStyled,
  NewDescriptionStyles,
  NewLinkStyles,
  LoadMoreButtonStyles
} from "./vertical-gaming-news-styles"
import { ContentWrapper as GlobalContentWrapper } from "../../ui/content-wrapper/content-wrapper-elements"

export const SectionWrapper = styled.div`
  ${SectionWrapperStyles}
`

export const SectionName = styled.h3`
  ${SectionNameStyles};
`

export const ContentWrapper = styled(GlobalContentWrapper)`
  ${ContentWrapperStyles}
`

export const NewsWrapper = styled.div`
  ${NewsWrapperStyles}
`

export const NewContent = styled.div`
  ${NewContentStyles}
`

export const NewLeftBlock = styled.div`
  ${NewLeftBlockStyles}
`

export const NewRightBlock = styled.div`
  ${NewRightBlockStyles}
`

export const NewAssetWrapper = styled.div`
  ${NewAssetWrapperStyles}
`

export const NewAsset = styled.img`
  ${NewAssetStyles}
`

export const LoadMoreButton = styled.div`
  ${LoadMoreButtonStyles}
`

export const NewTitle = styled.p`
  ${NewTitleStyles}
`

export const NewGameName = styled.p`
  ${NewGameNameStyles}
`

export const NewGameDate = styled.div`
  ${NewGameDateStyled}
`

export const NewDescription = styled.p`
  ${NewDescriptionStyles}
`

export const NewLink = styled.div`
  ${NewLinkStyles}
`
